var _path, _path2, _ellipse, _ellipse2, _path3, _path4, _g, _path5, _path6, _g2, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewAvatar3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1312_6086)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1684 5.86865C9.09844 5.86865 3.38279 15.4283 6.01035 32.5861C6.17747 33.6774 7.12882 34.4687 8.23282 34.4687H36.1648C37.2415 34.4687 38.178 33.7159 38.3702 32.6566C41.4378 15.7531 34.8952 5.86865 22.1684 5.86865Z",
    fill: "#E97736"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6504 27.208C33.6504 21.1328 28.7255 16.1353 22.6504 16.1353C16.5753 16.1353 11.6504 21.1328 11.6504 27.208C11.6504 32.801 16.1844 37.4019 21.7774 37.4019H23.5234C29.1164 37.4019 33.6504 32.801 33.6504 27.208Z",
    fill: "#F9B79E"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.22429,
    cy: 2.53227,
    rx: 2.22429,
    ry: 2.53227,
    transform: "matrix(-1 0 0 1 36.2812 25.1182)",
    fill: "#F9B79E"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.1091,
    cy: 27.6504,
    rx: 2.22429,
    ry: 2.53227,
    fill: "#F9B79E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9629 27.4442C19.9629 28.956 18.7373 30.1816 17.2254 30.1816H16.7423C16.0012 30.1816 15.4004 29.5809 15.4004 28.8397V26.9879C15.4004 25.728 16.4218 24.7067 17.6817 24.7067C18.9415 24.7067 19.9629 25.728 19.9629 26.9879V27.4442Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1312_6086",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 24,
    width: 5,
    height: 7
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9648 27.4442C19.9648 28.956 18.7392 30.1816 17.2274 30.1816H16.7443C16.0032 30.1816 15.4024 29.5809 15.4024 28.8397V26.9879C15.4024 25.728 16.4237 24.7067 17.6836 24.7067C18.9435 24.7067 19.9648 25.728 19.9648 26.9879V27.4442Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1312_6086)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.73748,
    height: 3.64997,
    rx: 1.36874,
    transform: "matrix(-1 0 0 1 19.1191 25.5581)",
    fill: "#343434"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.627 28.8387C29.627 29.5799 29.0261 30.1807 28.285 30.1807H27.8019C26.29 30.1807 25.0643 28.955 25.0643 27.4431V26.9868C25.0643 25.7269 26.0857 24.7055 27.3456 24.7055C28.6056 24.7055 29.627 25.7269 29.627 26.9868V28.8387Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1312_6086",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 24,
    width: 5,
    height: 7
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.627 28.8387C29.627 29.5799 29.0261 30.1807 28.285 30.1807H27.8019C26.29 30.1807 25.0643 28.955 25.0643 27.4431V26.9868C25.0643 25.7269 26.0857 24.7055 27.3456 24.7055C28.6056 24.7055 29.627 25.7269 29.627 26.9868V28.8387Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1312_6086)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.73759,
    height: 3.65012,
    rx: 1.3688,
    transform: "matrix(-1 0 0 1 28.7832 25.5571)",
    fill: "#343434"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2852 23.0622C27.6697 22.54 26.8078 22.5725 25.1788 23.0622",
    stroke: "#E97736",
    strokeWidth: 1.49592,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6406 23.0622C18.0252 22.54 17.1632 22.5725 15.5342 23.0622",
    stroke: "#E97736",
    strokeWidth: 1.49592,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7664 19.8022C11.2338 24.5437 11.3292 27.0735 12.7664 31.8546",
    stroke: "#E97736",
    strokeWidth: 1.83333,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1848 19.8022C33.7174 24.5437 33.622 27.0735 32.1848 31.8546",
    stroke: "#E97736",
    strokeWidth: 1.83333,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2529 32.0474C24.2529 32.0474 23.8304 32.7541 22.4863 32.754",
    stroke: "#FA7254",
    strokeWidth: 0.88,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2002 29.1206L22.2549 26.1346C22.3301 25.9217 22.6311 25.9217 22.7063 26.1346L23.761 29.1206C24.0731 30.0041 23.4177 30.9308 22.4806 30.9308C21.5436 30.9308 20.8882 30.0041 21.2002 29.1206Z",
    fill: "#FA8E67"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.517 6.25537C15.024 6.25537 11.6201 11.1246 12.8384 19.8943C12.9884 20.974 13.9375 21.7434 15.0276 21.7434H30.0714C31.132 21.7434 32.0652 21.0152 32.2389 19.969C33.6785 11.2998 29.8203 6.25537 22.517 6.25537Z",
    fill: "#E97736"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1312_6086"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.00195312,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewAvatar3);
export default __webpack_public_path__ + "static/media/review_avatar_3.9f210e6e88aa5ca3cd009b5ec01866ec.svg";
export { ForwardRef as ReactComponent };